function randomHex(bytes: number): string {
  const data = new Uint8Array(bytes);
  crypto.getRandomValues(data);
  return Array.from(data, (value) => value.toString(16).padStart(2, "0")).join("");
}

function nonZeroHex(bytes: number): string {
  let value = randomHex(bytes);
  while (/^0+$/.test(value)) {
    value = randomHex(bytes);
  }
  return value;
}

export function createTraceparent(): string {
  return `00-${nonZeroHex(16)}-${nonZeroHex(8)}-01`;
}

export function traceIdFromTraceparent(traceparent: string): string {
  return traceparent.split("-")[1] ?? "";
}

export function createTraceHeaders(): Record<string, string> {
  const traceparent = createTraceparent();
  return {
    traceparent,
    "X-Trace-Id": traceIdFromTraceparent(traceparent),
  };
}
